<template>
  <div class="alert alert-danger text-center space-box-alert-custom">
    <p>無地ダンボール設定の確認が出来ていません。</p>
    <p>以下の手順を確認して無地ダンボールの設定を行ってください。</p>
    <p>→<a class="text--underline" :href="downloadUrl" target="_blank"><span>設定方法</span></a></p>
    <p>※無地のダンボール設定が完了していない場合、他モールで販売が開始されない場合があります。</p>
  </div>
</template>
<script>
export default {
  data () {
    return {
      downloadUrl: `${process.env.NODE_DOMAIN}/static/dists/pdf/Plaincardboard.pdf`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NoDanboard.vue